import types from './actionTypes';
import initialFilters from '../../config/filters';

const initialState = {
  loading: false,
  startDate: null,
  endDate: null,
  filters: { ...initialFilters },
  error: '',
};

const callInsightReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_CALL_INSIGHT_STATE:
      return initialState;
    case types.SET_CALL_INSIGHT_FILTERS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.SET_CALL_INSIGHT_FILTERS.SUCCESS:
      return {
        ...state,
        loading: false,
        startDate: action.startDate,
        endDate: action.endDate,
        filters: { ...action.filters },
        error: '',
      };
    case types.SET_CALL_INSIGHT_FILTERS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default callInsightReducer;
